<div class="modal-body">
   {{message}}
</div>
<div class="modal-footer">
    <p-button label="Ok" size="small" (click)="dialogRef.close()"> </p-button>
</div>
